// extracted by mini-css-extract-plugin
var _1 = "RyzOvVHPCiILVtVP9Iyv";
var _2 = "vU6m_tF8xjYWhBJGtyeC";
var _3 = "vU6m_tF8xjYWhBJGtyeC";
var _4 = "LRoOR1DXLMpUoK2Myj7i";
var _5 = "XPS00o8W2gIKwAj8tBtd";
var _6 = "XPS00o8W2gIKwAj8tBtd";
var _7 = "Jf3lTAuwxQSQT8NwDXMI";
var _8 = "rCo8vYWk4rYP5N9Qvz29";
var _9 = "MzDoV1YfjNMO_TStzC7L";
var _a = "MzDoV1YfjNMO_TStzC7L";
var _b = "Xd03o1hkDAUJcaqC7H_X";
var _c = "b6JIz6nTPsmZzV_z897z";
var _d = "k8FAvUBLnugun1bvqsr4";
var _e = "k8FAvUBLnugun1bvqsr4";
export { _1 as "container", _2 as "container-sidenav", _3 as "containerSidenav", _4 as "flex", _5 as "general-dashboard", _6 as "generalDashboard", _7 as "logo", _8 as "navbar", _9 as "no-print", _a as "noPrint", _b as "paragraph", _c as "section", _d as "take-chat", _e as "takeChat" }
